import createIcon from '../../createIcon';

/**
 * @component @name CreateNewFolder
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgNkgxMkwxMCA0SDRDMi44OSA0IDIuMDEgNC44OSAyLjAxIDZMMiAxOEMyIDE5LjExIDIuODkgMjAgNCAyMEgyMEMyMS4xMSAyMCAyMiAxOS4xMSAyMiAxOFY4QzIyIDYuODkgMjEuMTEgNiAyMCA2Wk0xOSAxNEgxNlYxN0gxNFYxNEgxMVYxMkgxNFY5SDE2VjEySDE5VjE0WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const CreateNewFolder = createIcon('CreateNewFolder', [
  [
    'path',
    {
      d: 'M20 6H12L10 4H4C2.89 4 2.01 4.89 2.01 6L2 18C2 19.11 2.89 20 4 20H20C21.11 20 22 19.11 22 18V8C22 6.89 21.11 6 20 6ZM19 14H16V17H14V14H11V12H14V9H16V12H19V14Z',
      key: 'zsbj5k',
    },
  ],
]);

export default CreateNewFolder;
